import { render } from "./CompetitionsRegionMain.vue?vue&type=template&id=6edd1423&scoped=true"
import script from "./CompetitionsRegionMain.vue?vue&type=script&lang=js"
export * from "./CompetitionsRegionMain.vue?vue&type=script&lang=js"

import "./CompetitionsRegionMain.vue?vue&type=style&index=0&id=6edd1423&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6edd1423"]])

export default __exports__